/**
 * @module BannerServiceCheckSingle Line
 * @description
 */
import React, { FC, useContext } from 'react';
import { createPortal } from 'react-dom';
import { FeatureFlagContext } from 'ui/providers/feature-flagging';
import ServiceCheckSingleLine from '~/core/ServiceCheckForm/ServiceCheckSingleLine';
import Component from 'ui/components/Component';
import styles from './styles/BannerServiceCheckSingleLine.module.css';

interface Props {
  theme?: 'Dark' | 'Blue';
  isSticky?: boolean;
  placement?: string;
}

const BannerServiceCheckSingleLine: FC<Props> = ( { ...props } ) => {
  const { phoneHeavy } = useContext( FeatureFlagContext );
  const {
    theme = null,
    isSticky = false,
    placement
  } = props;

  const isAltTheme = theme !== null;
  const themeClass = `is${ theme }`;

  if ( phoneHeavy === true ) {
    return null;
  }

  const component = (
    <Component
      inContainer
      placement={ placement }
      className={ `
        ${ styles.component }
        ${ isAltTheme && styles[ themeClass ] }
      ` }
    >
      <div className={ styles.body }>
        <div className={ styles.formWrapper }>
          <ServiceCheckSingleLine />
        </div>
      </div>
    </Component>
  );

  if (isSticky) {
    const masthead = document.getElementById('masthead');
    if (!masthead) {
      console.warn('Masthead element not found');
      return null;
    }
    return createPortal(component, masthead);
  }
  return component;
};

BannerServiceCheckSingleLine.displayName = 'BannerServiceCheckSingleLine';

export default BannerServiceCheckSingleLine;
